import { create } from 'zustand';

/**
 * Global sign-in overlay state. The OG opened auth as a modal over the current
 * page (`#authOverlay` + showLoginOverlay/hideLoginOverlay) rather than a route;
 * this store is the V2 equivalent, opened from the TopNav person button and the
 * Explore "Log In to Unlock" CTA.
 */
interface AuthModalState {
  open: boolean;
  openAuth: () => void;
  closeAuth: () => void;
}

export const useAuthModal = create<AuthModalState>((set) => ({
  open: false,
  openAuth: () => set({ open: true }),
  closeAuth: () => set({ open: false }),
}));
